export type NkuliPerformanceMark =
  | "auth_success"
  | "clerk_ready"
  | "convex_authenticated"
  | "first_run_state_resolved"
  | "whatsapp_first_painted";

export function markNkuliPerformance(mark: NkuliPerformanceMark) {
  if (!import.meta.env.DEV || typeof performance === "undefined") return;

  performance.mark(mark);
}
